import { useEffect, useState } from "react";
import { supabase } from "@/integrations/supabase/client";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableHeader,
  TableRow,
} from "@/components/ui/table";
import { format } from "date-fns";
import { fr } from "date-fns/locale";
import { toast } from "sonner";
import { useQuery } from "@tanstack/react-query";

interface EggProduction {
  id: string;
  production_date: string;
  quantity: number;
  notes: string;
}

interface EggProductionListProps {
  stockItemId: string;
}

export const EggProductionList = ({ stockItemId }: EggProductionListProps) => {
  const fetchProductions = async () => {
    if (!stockItemId) {
      throw new Error("ID du lot non valide");
    }

    const { data, error } = await supabase
      .from('egg_productions')
      .select('*')
      .eq('stock_item_id', stockItemId)
      .order('production_date', { ascending: false });

    if (error) throw error;
    return data || [];
  };

  const { data: productions, isLoading, error } = useQuery({
    queryKey: ['egg-productions', stockItemId],
    queryFn: fetchProductions,
    enabled: !!stockItemId,
  });

  if (isLoading) {
    return <div className="text-center py-4">Chargement...</div>;
  }

  if (error) {
    console.error("Erreur lors de la récupération des productions:", error);
    return <div className="text-center py-4 text-red-500">Erreur lors du chargement des productions</div>;
  }

  return (
    <div className="rounded-md border">
      <Table>
        <TableHeader>
          <TableRow>
            <TableHead>Date</TableHead>
            <TableHead>Quantité</TableHead>
            <TableHead>Notes</TableHead>
          </TableRow>
        </TableHeader>
        <TableBody>
          {productions && productions.length > 0 ? (
            productions.map((production) => (
              <TableRow key={production.id}>
                <TableCell>
                  {format(new Date(production.production_date), 'PPP', { locale: fr })}
                </TableCell>
                <TableCell>{production.quantity} œufs</TableCell>
                <TableCell>{production.notes || '-'}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={3} className="text-center py-4">
                Aucune production enregistrée
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </Table>
    </div>
  );
};